const Images={
    pic1:require("./logo.png"),
    pic2:require("./bg.png"),
    pic3:require("./bg2.jpg"),
    pic4:require("./pic4.jpg"),
    pic5:require("./pic5.jpg"),
    pic6:require("./pic6.jpg"),
    pic7:require("./pic7.jpg"),
    pic8:require("./pic8.jpg"),
    pic9:require("./pic9.jpg"),
    pic10:require("./pic10.jpg"),
    pic11:require("./pic11.jpg"),
    pic12:require("./pic12.jpg"),
    pic13:require("./pic13.jpg"),
    pic14:require("./pic14.jpg"),
    pic15:require("./pic15.jpg"),
    pic16:require("./pic16.jpg"),
    pic17:require("./pic17.jpg"),
    pic18:require("./pic18.jpg"),
    pic19:require("./pic19.jpg"),
    pic20:require("./pic20.jpg"),
    pic21:require("./pic21.jpg"),
    pic22:require("./pic22.jpg"),
    pic24:require("./pic24.jpg"),
    pic25:require("./pic25.jpg"),
    pic26:require("./pic26.jpg"),
    pic27:require("./pic27.jpg"),
    pic28:require("./pic28.jpg"),
    pic29:require("./pic29.jpg"),
    pic30:require("./pic30.jpg"),
    pic31:require("./pic31.jpg"),
    logoLarge:require("./logo-large.jpg"),
    facebook:require("./facebook.png"),
    email:require("./email.png"),
    google:require("./google.png"),
    selllogo:require("./Group 2776.png"),
    mobileicon:require("./mobileicon.png"),
    propertyimage:require("./propertyimage.jpg"),
   flat:require("./flat.png"),
   floor:require("./floor.png"),
   shop:require("./shop.png"),
   rooms:require("./rooms.png"),
   land:require("./land.png"),
  house:require("./house.jpg"),
 pngpic:require("./pngpic.png"),
 aboutcard1:require("./aboutcard1.jpg"),
 aboutcard2:require("./aboutcard2.jpg"),
 aboutcard3:require("./aboutcard3.jpg"),
 aboutcard4:require("./aboutcard4.jpg"),
 aboutcard5:require("./aboutcard5.jpg"),
 aboutcard6:require("./aboutcard6.jpg"),
 aboutcard7:require("./aboutcard7.jpg"),
 aboutcard8:require("./aboutcard8.jpg"),
 aboutcard9:require("./aboutcard9.jpg"),
 aboutcard10:require("./aboutcard10.jpg"),
 aboutcard11:require("./aboutcard11.jpg"),
 contactus:require("./contactus.jpg"),
 about:require("./about.jpg"),
 aboutstyle:require("./aboutstyle.jpg"),
 aboutfirst:require("./aboutfirst.jpg"),
chatwithus:require("./chatwithus.png"),
cellphone:require("./cellphone.png"),
getsupport:require("./getsupport.png"),
mediainquiry:require("./mediainquiry.png"),
thumbsup:require("./thumbsup.png"),
  

}
export default Images